var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgSearchOutline = function SvgSearchOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.75 3.5a7.25 7.25 0 104.45 12.974l4.264 4.262a.9.9 0 101.272-1.272L16.474 15.2A7.25 7.25 0 0010.75 3.5zm0 1.8a5.45 5.45 0 100 10.9 5.45 5.45 0 000-10.9z",
    fill: "#023F80"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC43NSAzLjVDNi43NDU5NCAzLjUgMy41IDYuNzQ1OTQgMy41IDEwLjc1QzMuNSAxNC43NTQxIDYuNzQ1OTQgMTggMTAuNzUgMThDMTIuNDI3NyAxOCAxMy45NzIyIDE3LjQzMDIgMTUuMjAwNyAxNi40NzM1TDE5LjQ2MzYgMjAuNzM2NEMxOS44MTUxIDIxLjA4NzkgMjAuMzg0OSAyMS4wODc5IDIwLjczNjQgMjAuNzM2NEMyMS4wODc4IDIwLjM4NDkgMjEuMDg3OCAxOS44MTUxIDIwLjczNjQgMTkuNDYzNkwxNi40NzM1IDE1LjIwMDdDMTcuNDMwMiAxMy45NzIyIDE4IDEyLjQyNzcgMTggMTAuNzVDMTggNi43NDU5NCAxNC43NTQxIDMuNSAxMC43NSAzLjVaTTEwLjc1IDUuM0M3Ljc0MDA1IDUuMyA1LjMgNy43NDAwNSA1LjMgMTAuNzVDNS4zIDEzLjc2IDcuNzQwMDUgMTYuMiAxMC43NSAxNi4yQzEzLjc2IDE2LjIgMTYuMiAxMy43NiAxNi4yIDEwLjc1QzE2LjIgNy43NDAwNSAxMy43NiA1LjMgMTAuNzUgNS4zWiIgZmlsbD0iIzAyM0Y4MCIvPgo8L3N2Zz4K";
export { SvgSearchOutline as ReactComponent };